const publicRouter = [
	{
		path: '/public/register',
		name: 'Register',
		component: () => import('@/views/public/Register')
	},
	{
		path: '/public/articleList',
		name: 'ArticleList',
		component: () => import('@/views/public/ArticleList')
	},
	{
		path: '/public/articleInfo',
		name: 'ArticleInfo',
		component: () => import('@/views/public/ArticleInfo')
	},
	{
		path: '/public/branchList',
		name: 'BranchList',
		component: () => import('@/views/public/BranchList')
	},
	{
		path: '/public/branchInfo',
		name: 'BranchInfo',
		component: () => import('@/views/public/BranchInfo')
	},
]
export default publicRouter
